import MPlayer from "../assets/images/Projects/Mplayer/Mplayer_web.png";
import Joke from "../assets/images/Projects/Joke/Joke.png";
import Hotel from "../assets/images/Projects/Hotel/Hotel.png";
import Cinezone from "../assets/images/Projects/Cinezone/Cinezone.png";
import Mini1 from "../assets/images/Projects/Mini1/Mini1.png";
import Mini2 from "../assets/images/Projects/Mini2/Mini2.png";
import Capstone from "../assets/images/Projects/Capstone/Capstone.png";

const wdatas = [
  {
    title: "Bayler View Hotel",
    repo: "https://github.com/chardtmbng02/Mini-Project-01",
    live: "https://bayler-view-hotels.netlify.app/index.html",
    image: Mini1,
    description:
      "A Website that showcases the beauty of a beach resort located at Baler, Aurora, Philippines.",
    date: "April 2023",
    technologies: ["HTML", " | ", "Bootstrap"],
  },
  {
    title: "Hotel Team Azur",
    repo: "https://github.com/chardtmbng02/Hotel_Responsive",
    live: "https://hotel-team-7.netlify.app/",
    image: Hotel,
    description:
      "A website designed for browsing movies using an api.",
    date: "May 2023",
    technologies: ["HTML", " | ", "CSS"],
  },
  {
    title: "CineZone",
    repo: "https://github.com/chardtmbng02/cine_zone",
    live: "https://cinezone-team-7.netlify.app/",
    image: Cinezone,
    description:
      "A website designed for browsing movies using an api.",
    date: "May 2023",
    technologies: ["HTML | CSS | JS"],
  },
  {
    title: "Joke Generator",
    repo: "https://github.com/chardtmbng02/Joke_Generator",
    live: "https://joke-generator-team-7.netlify.app/",
    image: Joke,
    description:
      "Random joke generator using Chuck Norris Joke Api.",
    date: "May 2023",
    technologies: ["HTML", " | ", "JS"],
  },
  {
    title: "Chef Murk Kitchen",
    repo: "https://github.com/chardtmbng02/chef_murk_kitchen",
    live: "https://cmktm7.vercel.app/",
    image: Mini2,
    description:
      "This is a Food Directory Website where users can search specific food and view its recipes and nutrition benefits.",
    date: "June 2023",
    technologies: ["ReactJS", " | ", "Tailwind", " | ", "API"],
  },
  {
    title: "Music Player",
    repo: "https://github.com/chardtmbng02/MusicPlayer_FE",
    live: "https://mplayer-chard.vercel.app",
    image: MPlayer,
    description:
      "Simple Music Player with Play, Pause, Next, and Previous Function.",
    date: "July 2023",
    technologies: ["HTML", " | ", "JS"],
  },
  {
    title: "Rooms Reservation System",
    repo: "https://github.com/chardtmbng02/baylerview",
    live: "https://baylerview-hotel.vercel.app/",
    image: Capstone,
    description:
      "Web application that lets users explore a wide variety of accommodations and perfect rooms in just a few clicks.",
    date: "July 2023",
    technologies: ["MERN", " | ", "Tailwind"],
  },
  
  
];

export default wdatas;
